import { useGetWhitelabel } from '@/Hooks'

export const WhitelabelProvider = ({ children }) => {
  const whitelabel = useGetWhitelabel()

  return children(whitelabel)
}
